<div>
  <div class="container">

    <div class="title-container">
      <p i18n class="section-pre-header" i18n="@@popularDishes">Popular Dishes</p>
      <img class="section-left-img" src="assets/merchant-landing-page/benefits-header-icon-1.png"/>
      <img class="section-right-img" src="assets/merchant-landing-page/benefits-header-icon-2.png"/>
      <img class="section-left-dot" src="assets/merchant-landing-page/rectangle-red-icon.png"/>
      <img class="section-right-dot" src="assets/merchant-landing-page/rectangle-yellow-icon.png"/>

      <h1 i18n>What’s Cooking?</h1>
    </div>
    <div class="featured-chefs-desc">
      <p i18n>Tempt your taste buds with our most-loved dishes, chosen by customers like you. Whether you're in the mood
        for comforting classics or bold flavors, there's always something new to discover</p>
    </div>
  </div>

  <div class="featured-chefs-items-container" #featuredItemsContainer>
      <featured-dish
        *ngFor="let product of products"
        [product]="product">
      </featured-dish>
  </div>
  <!--  <div class="text-center mx-1">-->
  <!--    <button class="button-primary" routerLink="/merchants/signup" routerLinkActive="active">-->
  <!--      Explore All Dishes-->
  <!--    </button>-->
  <!--  </div>-->
</div>
